// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColorLevelBar_level-container__uzLvD {
  padding: 1px;
  display: flex;
  width: 100%;
  height: 100%;
}

.ColorLevelBar_level__ekzH3 {
  flex: 1 1;
  margin: 1px;
  border-radius: 3px;
}

.ColorLevelBar_no-data__cJqh2 {
  width: 100%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/ColorLevelBar.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF","sourcesContent":[".level-container {\n  padding: 1px;\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.level {\n  flex: 1;\n  margin: 1px;\n  border-radius: 3px;\n}\n\n.no-data {\n  width: 100%;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"level-container": `ColorLevelBar_level-container__uzLvD`,
	"level": `ColorLevelBar_level__ekzH3`,
	"no-data": `ColorLevelBar_no-data__cJqh2`
};
export default ___CSS_LOADER_EXPORT___;
